import { Link } from "react-router-dom";
import { Play, Eye, Clock, Flame } from "lucide-react";
import { formatViews, timeAgo } from "@/lib/api";

const VideoCard = ({ video, index = 0 }) => {
  return (
    <Link
      to={`/watch/${video.id}`}
      className="video-card block fade-up"
      style={{ animationDelay: `${Math.min(index * 40, 400)}ms` }}
      data-testid={`video-card-${video.id}`}
    >
      <div className="relative rounded-xl overflow-hidden bg-[var(--bg-card)] aspect-video-yt">
        <img
          src={video.thumbnail}
          alt={video.title}
          loading="lazy"
          className="w-full h-full object-cover"
          onError={(e) => { e.currentTarget.src = `https://i.ytimg.com/vi/${video.id}/mqdefault.jpg`; }}
        />
        {/* Bottom shadow */}
        <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/85 to-transparent" />

        {/* Play overlay on hover */}
        <div className="thumb-overlay absolute inset-0 bg-black/40 flex items-center justify-center">
          <div className="w-14 h-14 rounded-full bg-[var(--accent)] flex items-center justify-center shadow-2xl">
            <Play className="w-6 h-6 text-white fill-white ml-0.5" />
          </div>
        </div>

        {/* Top-left badge */}
        {video.is_short && (
          <span className="absolute top-2 left-2 tag bg-[var(--accent)] text-white">
            <Flame className="w-3 h-3" /> Short
          </span>
        )}

        {/* Bottom-right stats */}
        <div className="absolute bottom-2 right-2 flex items-center gap-1 text-[11px] text-white/90 bg-black/65 px-1.5 py-0.5 rounded">
          <Eye className="w-3 h-3" /> {formatViews(video.views)}
        </div>
      </div>

      <div className="pt-3 px-1">
        <h3 className="font-display text-[15px] sm:text-base font-semibold text-white clamp-2 leading-snug group-hover:text-[var(--accent)] transition-colors">
          {video.title}
        </h3>
        <div className="mt-1.5 flex items-center gap-2 text-xs text-[var(--text-muted)]">
          <Clock className="w-3 h-3" />
          <span>{timeAgo(video.published)}</span>
          <span>·</span>
          <span>{formatViews(video.views)} visualizações</span>
        </div>
      </div>
    </Link>
  );
};

export default VideoCard;
